/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
import { AppCSS, Spacer, TxtInput, ChkInputBox } from "../../../../components";
import { Lbl } from "../../../../components/labels";
import { ColDiv, RowDiv } from "../../../../components/misc/misc.styled";

import * as React from "react";
import { useDispatch } from "react-redux";
import { Container } from "../../../../globalstyled";

import { Box, Typography, Switch } from "@mui/material";
import UpArrowIcon from "../../../../images/UploadIcon.png";
import DownArrowIcon from "../../../../images/DownloadIcon.png";
import searchIcon from "../../../../images/searchIcon.png";

import LeadsTableHeaderCard from "../../../../components/table/CustomTableHeaderCard";
import LeadsTableBodyCard from "../../../../components/table/CustomTableBodyCard";
import { MISC_FIELDS_TABLE_HEADER_LIST } from "../../../../contants/dashboardHeader";

import MiscFieldsDrawer from "../SideDrawer/index";
import TableViewDetails from "../../../../components/table/TableViewDetails";
import { FormTitleTypography, ArrowIcon } from "../itemCreation.styled";

import CancelAndSubmitButtons from "../ItemCreationComponent/SubmitAndCancelButton";

import {
  MiscFields,
  ProductSystem,
  ProductSystemForMiscField,
} from "../../../../redux/types/creation";
import { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import SearchAndCreateComponent from "../ItemCreationComponent/SearchAndCreateComponent";
import SideDrawerHeader from "../SideDrawer/SideDrawerHeader";
import Pagination from "../ItemCreationComponent/Pagination";
import ViewRowDetailsDrawer from "../ItemCreationComponent/ViewFieldDetails";
import { MISC_FIELDS_DRAWER_DETAILS } from "../../../../contants/itemsCreation";
import { toast } from "react-toastify";
import { useArchiveMiscField, useCreateMiscField } from "../../../../apolloClient/hooks/itemCreation/createHooks";
import { CreateMiscFieldInput } from "../../../../types/graphQlQuery.interface";
import { extractCheckedIds } from "../../../../utils";
import EmptyTable from "../../../../components/table/EmptyTable";
import ProductSystemParentIdsTable from "../ItemCreationComponent/ProductSystemParentIdsTable";
import ConfirmationDialog from "../../../../components/dialogue/ConfirmationDialog";

interface MiscFieldsTableProps {
  miscFieldsData: MiscFields[];
  refetchMiscField?: Function;
  productsIds?: ProductSystem[];
  permissions?: boolean;
}

export const MiscFieldsTable: React.FC<MiscFieldsTableProps> = ({
  miscFieldsData,
  refetchMiscField,
  productsIds,
  permissions,
}) => {
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(8);
  const [keyword, setKeyword] = React.useState("");

  const inputRef = React.useRef<HTMLInputElement>(null);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openRowDetailsDrawer, setOpenRowDetailsDrawer] = React.useState(false);

  const [viewRowDetailsData, setViewRowDetailsData] =
    useState<MiscFields | null>(null);

  const [productSystemId, setProductSystemId] = useState<string>("");
  const [forCustomerDisplay, setForCustomerDisplay] = useState<boolean>(false);

  const [miscName, setMiscName] = useState<string>("");
  const [showProductSystemParent, setShowProductSystemParent] =
    useState<boolean>(false);

  const [checkboxStates, setCheckboxStates] = useState<{
    [key: number]: boolean;
  }>({});

  const { createMiscFields } = useCreateMiscField();
  const { archiveMiscFields } = useArchiveMiscField();
  
    const [openArchieveDialog, setOpenArchieveDialog] = useState(false);
    const [selectedMiscField, setSelectedMiscField] = useState<MiscFields | null>(null);
  
    const handleArchive = (row: MiscFields) => {
      setSelectedMiscField(row);
      setOpenArchieveDialog(true);
    };
  
    const confirmArchieve = async () => {
      if (selectedMiscField) {
        const success = await archiveMiscFields(selectedMiscField.id);
        if (success) {
          toast(`Miscellaneous Field Archived!`, { type: "error" });
          refetchMiscField();
        } else {
          toast(`Failed to Archive Miscellaneous Field`);
        }
        setOpenArchieveDialog(false);
        setSelectedMiscField(null);
      }
    };
  
    const cancelArchieve = () => {
      setOpenArchieveDialog(false);
      setSelectedMiscField(null);
    };

  const handleSearchIconClick = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  const filterMiscFields = () => {
    if (keyword.length > 0 && Array.isArray(miscFieldsData)) {
      return miscFieldsData.filter((item) => {
        const miscFieldName = `${item.name}`;
        return miscFieldName.toLowerCase().includes(keyword.toLowerCase());
      });
    }
    return miscFieldsData;
  };

  const goToPreviousPage = () => {
    setPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const goToNextPage = () => {
    setPage((prevPage) =>
      Math.min(
        prevPage + 1,
        Math.ceil(filterMiscFields().length / rowsPerPage) - 1
      )
    );
  };

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const handleViewRowDetailsDrawerOpen = () => {
    setOpenRowDetailsDrawer(true);
  };

  const handleViewRowDetailsDrawerClose = () => {
    setOpenRowDetailsDrawer(false);
  };

  const onTapSubmitForm = async () => {
    const validationRules = [
      {
        condition: !miscName,
        message: "Please enter misc field name!",
      },

      {
        condition: !extractCheckedIds(checkboxStates).length,
        message: "Please select a minimum of one product system!",
      },
    ];

    for (const rule of validationRules) {
      if (rule.condition) {
        toast(rule.message, {
          type: "error",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
    }

    const checkedParentIds = extractCheckedIds(checkboxStates);

    const input: CreateMiscFieldInput = {
      showToCustomer: forCustomerDisplay,
      name: miscName,
      parentIds: checkedParentIds,
    };

    const success = await createMiscFields(input);
    if (success) {
      toast("Misc field created successfully.", {
        type: "success",
        className: "toast-message",
        position: "top-left",
      });
      refetchMiscField();
      handleDrawerClose();
      setMiscName("");
      setForCustomerDisplay(false);
      setCheckboxStates({});
      return;
    } else {
      console.log("Failed to create Misc field.");
    }
  };

  const viewRowDetails = (rowData: MiscFields) => {
    setViewRowDetailsData(rowData);
    handleViewRowDetailsDrawerOpen();
  };

  const createMiscFieldsForm = () => {
    return (
      <MiscFieldsDrawer open={openDrawer} onClose={() => handleDrawerClose()}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            width: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={handleDrawerClose}
            labelTitle="Create new miscellaneous field"
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              width: { xs: "100%", md: "97%" },
            }}
          >
            {/* Field name */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#1a1a2e",
                }}
              >
                Field name *
              </Typography>
              <TxtInput
                placeholder="Enter name"
                onChange={setMiscName}
                required={true}
                value={miscName}
                background="inherit"
                borderColor="rgba(173, 173, 173, 1)"
                borderRadius={10}
                height={50}
              />
            </Box>

            {/* Associated product systems */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#1a1a2e",
                }}
              >
                Associated product systems *
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "inherit",
                  borderRadius: "10px",
                  border: "1px solid rgba(173, 173, 173, 1)",
                  height: "fit-content",
                  minHeight: "50px",
                  paddingY: "10px",
                  cursor: "pointer",
                }}
                onClick={() =>
                  setShowProductSystemParent(!showProductSystemParent)
                }
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    paddingX: "20px",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography sx={{ fontSize: 14, color: "#6b7280" }}>
                    Select associated product systems
                  </Typography>
                  <ArrowIcon src={showProductSystemParent ? UpArrowIcon : DownArrowIcon} />
                </Box>

                {showProductSystemParent && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "start",
                      width: "100%",
                      paddingX: "20px",
                      gap: "8px",
                    }}
                  >
                    {productsIds.map((item) => (
                      <Box
                        key={`checkProductsSystemParent ${item.id}`}
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          cursor: "pointer",
                          justifyContent: "start",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <ChkInputBox
                          onChange={(value: boolean) => {
                            setCheckboxStates((prevCheckboxStates) => ({
                              ...prevCheckboxStates,
                              [item.id]: value,
                            }));
                            setShowProductSystemParent(true);
                          }}
                          placeholder=""
                          width={50}
                          marginTop={0}
                          marginBottom={0}
                          height={20}
                          background="inherit"
                          checked={checkboxStates[item.id] || false}
                        />
                        <Typography sx={{ fontSize: 14 }}>{item.name}</Typography>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            </Box>

            {/* For customer display */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#1a1a2e",
                }}
              >
                For customer display
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <ChkInputBox
                  onChange={(value) => {
                    setForCustomerDisplay(value);
                  }}
                  placeholder=""
                  width={50}
                  background="inherit"
                  marginBottom={0}
                  marginTop={0}
                  checked={forCustomerDisplay}
                />
                <Typography sx={{ fontSize: 14, color: "#374151" }}>
                  Display in customer project portal
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <CancelAndSubmitButtons
          onCancel={handleDrawerClose}
          onCreate={onTapSubmitForm}
        />
      </MiscFieldsDrawer>
    );
  };

  const showMiscFieldsRowDetails = () => {
    return (
      <ViewRowDetailsDrawer
        openDrawer={openRowDetailsDrawer}
        handleDrawerClose={handleViewRowDetailsDrawerClose}
        rowDetailsData={viewRowDetailsData}
        labelTitle="Miscellaneous Fields Details"
        rowArrayTableComponent={(
          value: ProductSystemForMiscField[],
          key?: string
        ) => <ProductSystemParentIdsTable value={value} key={key} />}
        detailsOfRowToBeDisplay={MISC_FIELDS_DRAWER_DETAILS}
      />
    );
  };

  const MiscFieldTable = () => {
    const paginatedData = filterMiscFields().slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
    const totalPages = Math.ceil(filterMiscFields().length / rowsPerPage);

    return (
      <Box sx={{ width: "100%" }}>
        {/* Search and Create Button */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "stretch", md: "center" },
            gap: 2,
            mb: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "white",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              height: "44px",
              width: { xs: "100%", md: "320px" },
              transition: "border-color 0.2s, box-shadow 0.2s",
              "&:focus-within": {
                borderColor: "#4b87ed",
                boxShadow: "0 0 0 3px rgba(75, 135, 237, 0.1)",
              },
            }}
          >
            <Box
              component="img"
              src={searchIcon}
              sx={{ width: 16, height: 16, cursor: "pointer", margin: "0 12px" }}
              onClick={handleSearchIconClick}
            />
            <TxtInput
              placeholder="Search miscellaneous fields"
              onChange={setKeyword}
              inputRef={inputRef}
              background="white"
              width="100%"
            />
          </Box>

          {permissions && (
            <Box
              component="button"
              onClick={handleDrawerOpen}
              sx={{
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
                transition: "all 0.2s",
                backgroundColor: "#4b87ed",
                color: "white",
                border: "none",
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor: "#3a6fd8",
                },
              }}
            >
              + Create new field
            </Box>
          )}
        </Box>

        {/* Table */}
        <Box
          sx={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            overflow: "hidden",
          }}
        >
          {/* Desktop Table Header */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              padding: "14px 20px",
              backgroundColor: "#f3f4f6",
              borderBottom: "1px solid #e5e7eb",
              fontWeight: 600,
              fontSize: 12,
              color: "#6b7280",
              textTransform: "uppercase",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "15%", minWidth: "60px" }}>ID</Box>
            <Box sx={{ width: "45%", minWidth: "150px" }}>Name</Box>
            <Box sx={{ width: "40%", minWidth: "180px", textAlign: "right" }}>Actions</Box>
          </Box>

          {/* Table Body */}
          {filterMiscFields().length === 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "48px 24px",
                textAlign: "center",
              }}
            >
              <Typography sx={{ fontSize: 15, color: "#6b7280", margin: 0 }}>
                No miscellaneous fields available
              </Typography>
            </Box>
          ) : (
            paginatedData.map((row, rowIndex) => (
              <Box
                key={`misc-field-${rowIndex}`}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { xs: "flex-start", md: "center" },
                  padding: { xs: "14px 16px", md: "14px 20px" },
                  borderBottom: "1px solid #f0f0f0",
                  gap: { xs: 1, md: 0 },
                  width: "100%",
                  "&:hover": {
                    backgroundColor: "#f8f9fa",
                  },
                  "&:last-child": {
                    borderBottom: "none",
                  },
                }}
              >
                {/* ID */}
                <Box sx={{ width: { xs: "100%", md: "15%" }, minWidth: { md: "60px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    ID
                  </Typography>
                  <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#1a1a2e" }}>
                    {row.id}
                  </Typography>
                </Box>

                {/* Name */}
                <Box sx={{ width: { xs: "100%", md: "45%" }, minWidth: { md: "150px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    Name
                  </Typography>
                  <Typography sx={{ fontSize: 14, color: "#374151" }}>
                    {row.name}
                  </Typography>
                </Box>

                {/* Actions */}
                <Box
                  sx={{
                    width: { xs: "100%", md: "40%" },
                    minWidth: { md: "180px" },
                    display: "flex",
                    justifyContent: { xs: "flex-start", md: "flex-end" },
                    gap: 1,
                    flexWrap: "wrap",
                    marginTop: { xs: 1, md: 0 },
                  }}
                >
                  <Box
                    component="button"
                    onClick={() => viewRowDetails(row)}
                    sx={{
                      padding: "8px 16px",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: 500,
                      cursor: "pointer",
                      transition: "all 0.2s",
                      backgroundColor: "#e5e7eb",
                      color: "#374151",
                      border: "none",
                      "&:hover": {
                        backgroundColor: "#d1d5db",
                      },
                    }}
                  >
                    View
                  </Box>
                  {permissions && (
                    <Box
                      component="button"
                      onClick={() => handleArchive(row)}
                      sx={{
                        padding: "8px 16px",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: 500,
                        cursor: "pointer",
                        transition: "all 0.2s",
                        backgroundColor: "#fee2e2",
                        color: "#dc2626",
                        border: "none",
                        "&:hover": {
                          backgroundColor: "#fecaca",
                        },
                      }}
                    >
                      Archive
                    </Box>
                  )}
                </Box>
              </Box>
            ))
          )}

          {/* Pagination */}
          {filterMiscFields().length > 0 && totalPages > 1 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "center", md: "flex-end" },
                padding: "14px 20px",
                gap: 1,
                borderTop: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
              }}
            >
              <Box
                component="button"
                onClick={goToPreviousPage}
                disabled={page === 0}
                sx={{
                  px: 2,
                  py: 1,
                  border: "none",
                  borderRadius: "6px",
                  backgroundColor: page === 0 ? "#f3f4f6" : "#e5e7eb",
                  color: page === 0 ? "#9ca3af" : "#374151",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: page === 0 ? "not-allowed" : "pointer",
                  "&:hover": page === 0 ? {} : { backgroundColor: "#d1d5db" },
                }}
              >
                ← Prev
              </Box>
              <Typography sx={{ fontSize: 14, color: "#6b7280", margin: "0 8px" }}>
                Page {page + 1} of {totalPages}
              </Typography>
              <Box
                component="button"
                onClick={goToNextPage}
                disabled={page >= totalPages - 1}
                sx={{
                  px: 2,
                  py: 1,
                  border: "none",
                  borderRadius: "6px",
                  backgroundColor: page >= totalPages - 1 ? "#f3f4f6" : "#e5e7eb",
                  color: page >= totalPages - 1 ? "#9ca3af" : "#374151",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: page >= totalPages - 1 ? "not-allowed" : "pointer",
                  "&:hover": page >= totalPages - 1 ? {} : { backgroundColor: "#d1d5db" },
                }}
              >
                Next →
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    );
  };

  const MiscFieldContainer = () => {
    return (
      <Box sx={{ width: "100%" }}>
        {Array.isArray(miscFieldsData) && MiscFieldTable()}
        {createMiscFieldsForm()}
        {showMiscFieldsRowDetails()}
      </Box>
    );
  };

  return (
    <>
      {MiscFieldContainer()}
      <ConfirmationDialog
        open={openArchieveDialog}
        title="Confirm Archive"
        message={`Are you sure you want to Archive "${selectedMiscField?.name}"?`}
        onConfirm={confirmArchieve}
        onCancel={cancelArchieve}
      />
    </>
  );
};
